// import Appdetails from "../../assets/img/sidebaricon/appdetails.png";
// import myplayhistory from "../../assets/img/sidebaricon/myplayhistory.png";
// import Gameposting from "../../assets/img/sidebaricon/gameposting.png";
// import bonusreport from "../../assets/img/sidebaricon/bonusreport.png";
// import referandearn from "../../assets/img/sidebaricon/referandearn.png";
// import resulthistory from "../../assets/img/sidebaricon/resulthistory.png";
// import share from "../../assets/img/sidebaricon/share.png";
// import termsandcondition from "../../assets/img/sidebaricon/termsandcondition.png";
// import rateapp from "../../assets/img/sidebaricon/rateapp.png";
// import logout from "../../assets/img/sidebaricon/logout.png";
// import * as Icon from "react-bootstrap-icons";

// const handleShare = () => {
//   if (navigator.share) {
//     navigator
//       .share({
//         title: "Check out this app!",
//         url: "https://ranabhaimatka.com/",
//       })
//       .then(() => console.log("Shared successfully"))
//       .catch((error) => console.error("Error sharing:", error));
//   } else {
//     const unsupportedBrowserMessage = `
//       Sharing is not supported in this browser.
//       To share, please manually copy and paste the following link:
//       https://ranabhaimatka.com/
//     `;
//     alert(unsupportedBrowserMessage);
//   }
// };

// const referCondition = localStorage.getItem("ref_status");
// // alert(referCondition);
// const Sidebardata = [
//   {
//     title: "Set MPIN",
//     path: "/setmpin",
//     icon: <img alt="game" src={referandearn} />,
//     ownclass: "d-flex align-items-center link-page navlink-design",
//   },

//   {
//     title: "App Details",
//     path: "/Appdetails",
//     icon: <img alt="game" src={Appdetails} />,
//     ownclass: "d-flex align-items-center link-page navlink-design",
//   },

//   {
//     title: "My Play History",
//     path: "/History",

//     icon: <img alt="game" src={myplayhistory} />,
//     ownclass: "d-flex align-items-center link-page navlink-design",
//   },
//   // {
//   //   title: "App Commission",
//   //   path: "/AppCommission",

//   //   icon: <img alt="game" src={myplayhistory} />,
//   //   ownclass: "d-flex align-items-center link-page navlink-design",
//   // },

//   {
//     title: "Game Posting",
//     path: "/Gameposting",
//     icon: <img alt="game" src={Gameposting} />,
//     ownclass: "d-flex align-items-center link-page navlink-design",
//   },

//   {
//     title: "Refer & Earn",
//     path: "/Bonus-Report",
//     // hinditext: "अपनी गेम का कमीशन देखने के लिए यहाँ दबाये।",
//     icon: <img alt="game" src={bonusreport} />,
//     ownclass:
//       "d-flex align-items-center link-page navlink-design bgcolornewdesign",
//   },

//   // {
//   //   title: "Reffer & Earn",
//   //   path: "/Reffer-Report",
//   //   // hinditext: "रेफ़र एंड अर्न।",
//   //   icon: <img alt="game" src={referandearn} />,
//   //   ownclass: "d-flex align-items-center link-page navlink-design",
//   // },
//   // ...(referCondition == 1
//   //   ? [
//   //       {
//   //         title: "Reffer & Earn",
//   //         path: "/Reffer-Report",
//   //         icon: <img alt="game" src={referandearn} />,
//   //         ownclass:
//   //           "d-flex align-items-center link-page navlink-design bgcolornewdesign",
//   //       },
//   //     ]
//   //   : []),

//   {
//     title: "Result History",
//     path: "/Resulthistory",
//     // hinditext: "गेम के रिजल्ट देखने के लिए यहाँ दबाये।",
//     icon: <img alt="game" src={resulthistory} />,
//     ownclass: "d-flex align-items-center link-page navlink-design",
//   },

//   {
//     title: "Terms And Condtion",
//     path: "/Termsandcondition",
//     icon: <img alt="game" src={termsandcondition} />,
//     // hinditext: "नियम एवं शर्ते।",
//     ownclass: "d-flex align-items-center link-page navlink-design",
//   },

//   {
//     title: "Share",
//     // hinditext: "जो भाई गली दिसावर प्ले करते है व्हाट्सअप पर शेयर करे।",
//     onClick: handleShare,
//     icon: <img alt="game" src={share} />,
//     ownclass: "d-flex align-items-center link-page navlink-design",
//   },

//   {
//     title: "Rate Our App",
//     // hinditext: "ह  मारी एप्लिकेशन को सुझाव देने के लिए दबाये।",
//     path: "https://ranabhaimatka.com/",
//     icon: <img alt="game" src={rateapp} />,
//     ownclass: "d-flex align-items-center link-page navlink-design",
//   },

//   {
//     title: "Logout",
//     icon: <img alt="game" src={logout} />,
//     ownclass: "d-flex align-items-center link-page navlink-design",
//   },
// ];
// export default Sidebardata;

/////////////////////




import Appdetails from "../../assets/img/sidebaricon/appdetails.png";
import myplayhistory from "../../assets/img/sidebaricon/myplayhistory.png";
import Gameposting from "../../assets/img/sidebaricon/gameposting.png";
import bonusreport from "../../assets/img/sidebaricon/bonusreport.png";
import referandearn from "../../assets/img/sidebaricon/referandearn.png";
import resulthistory from "../../assets/img/sidebaricon/resulthistory.png";
import share from "../../assets/img/sidebaricon/share.png";
import termsandcondition from "../../assets/img/sidebaricon/termsandcondition.png";
import rateapp from "../../assets/img/sidebaricon/rateapp.png";
import logout from "../../assets/img/sidebaricon/logout.png";
import * as Icon from "react-bootstrap-icons";

// ✅ alert ki jagah on-screen message (WebView/APK mein bhi chalta hai)
const showMsg = (msg) => {
  const el = document.createElement("div");
  el.innerText = msg;
  el.style.cssText =
    "position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#000;color:#fff;padding:12px 18px;border-radius:8px;z-index:999999;max-width:80%;white-space:pre-line;text-align:center;font-size:14px";
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 4000);
};

const handleShare = async () => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: "Check out this app!",
        url: "https://ranabhaimatka.com/",
      });
    } catch (error) {
      console.error("Error sharing:", error);
    }
  } else {
    showMsg(
      "Sharing is not supported in this browser.\nLink copy karo: https://ranabhaimatka.com/"
    );
  }
};

// ✅ Install App Handler
const handleInstallClick = async () => {
  // alert("KJHDUKASHDASUK")
  // console.log("INSTALL CLICKED");
  // showMsg("Install click hua ✅"); 

  const isStandalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone;

  // 1. Already installed (sach mein standalone mode mein chal rahi hai)
  if (isStandalone) {
    showMsg("App already installed hai.");
    return;
  }

  // 2. Install prompt available hai
  const deferredPrompt = window.deferredPrompt;
  if (deferredPrompt) {
    try {
      deferredPrompt.prompt();
      const choiceResult = await deferredPrompt.userChoice;
      if (choiceResult.outcome === "accepted") {
        showMsg("✅ App install ho gayi!");
      } else {
        console.log("User ne dismiss kiya");
      }
      window.deferredPrompt = null;
    } catch (err) {
      console.error("Install error:", err);
      showMsg("Install nahi ho paya. Browser menu se try karo.");
    }
    return;
  }

  // 3. Fallback
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  if (isIOS) {
    showMsg(
      "iPhone pe install karne ke liye:\n1. Share button dabao\n2. 'Add to Home Screen' select karo"
    );
  } else {
    showMsg(
      // "Install prompt available nahi hai.\nBrowser menu (⋮) → 'Install App' ya 'Add to Home Screen' use karo."
    );
  }
};

const handleLogout = () => {
  // alert("hjf")
  localStorage.clear(); 
  window.location.href = "/";
};

const Sidebardata = [
  {
    title: "Set MPIN",
    path: "/setmpin",
    icon: <img alt="game" src={referandearn} />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "App Details",
    path: "/Appdetails",
    icon: <img alt="game" src={Appdetails} />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "My Play History",
    path: "/History",
    icon: <img alt="game" src={myplayhistory} />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Game Posting",
    path: "/Gameposting",
    icon: <img alt="game" src={Gameposting} />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Refer & Earn",
    path: "/Bonus-Report",
    icon: <img alt="game" src={bonusreport} />,
    ownclass:
      "d-flex align-items-center link-page navlink-design bgcolornewdesign",
  },
  {
    title: "Result History",
    path: "/Resulthistory",
    icon: <img alt="game" src={resulthistory} />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Terms And Condtion",
    path: "/Termsandcondition",
    icon: <img alt="game" src={termsandcondition} />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Share",
    onClick: handleShare,
    icon: <img alt="game" src={share} />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Rate Our App",
    path: "https://ranabhaimatka.com/",
    external: true,
    icon: <img alt="game" src={rateapp} />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Install Application ", // test ke baad "Install Application" kar dena
    onClick: handleInstallClick,
    icon: <Icon.Download />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
  {
    title: "Logout  ",
    onClick: handleLogout,
    icon: <img alt="game" src={logout} />,
    ownclass: "d-flex align-items-center link-page navlink-design",
  },
];

export default Sidebardata;
